import React, {useEffect} from "react";

import {isArray} from "chart.js/helpers";
import {useSelector} from "react-redux";
import {useGetEnumsQuery} from "../../../app/globalApi";
import {hasPermission} from "../../../helpers/utils/AccessControlUtils";
import TextAreaField from "../../../components/common/form/TextAreaField";
import InputField from "../../../components/common/form/InputField";
import CommonSelectDropDownTag from "../../../components/common/datatable/filter/CommonSelectDropDownTag";
import {createOptionListForSelectTag} from "../../../helpers/utils/Utils";
import SelectField from "../../../components/common/form/SelectField";

interface Props {
    noteBody: string;
    setNoteBody: (value: string) => void;
    bold?: any;
    setBold?: any;
    saveAsCanned: any;
    setSaveAsCanned: any;
    isExternalInternal: any;
    external: any;
    setExternal: any;
    isFulfillmentNotes: any;
    accountNumber: any;
    setAccountNumber: any;
    parentAccountData?: any[];
    yellowHighlight?: any;
    setYellowHighlight?: any;
    redColor?: any;
    setRedColor?: any;
    isCertificateNote: any;
    sort?: any;
    setSort?: any;
    targetCert?: string;
    setTargetCert?: any;
}

const CustomNoteSection: React.FC<Props> = ({
                                                noteBody,
                                                setNoteBody,
                                                bold = false,
                                                setBold = () => {
                                                },
                                                saveAsCanned,
                                                setSaveAsCanned,
                                                isExternalInternal,
                                                external,
                                                setExternal,
                                                isFulfillmentNotes,
                                                accountNumber,
                                                setAccountNumber,
                                                parentAccountData = [],
                                                yellowHighlight = false,
                                                setYellowHighlight = () => {
                                                },
                                                redColor = false,
                                                setRedColor = () => {
                                                },
                                                isCertificateNote,
                                                sort,
                                                setSort = () => {
                                                },
                                                targetCert = "",
                                                setTargetCert =  null
                                            }) => {


    const {data: enums} = useGetEnumsQuery("");

    useEffect(() => {
        if (isFulfillmentNotes && (!noteBody || noteBody === "")) {
            setNoteBody(accountNumber?.value);
        }
    }, [accountNumber]);

    const storageData = useSelector((state: any) => state.utilDataReducer);

    return (
        <>
            {isExternalInternal && storageData?.items?.customerLevel !== 'CUSTOMER' && (
                <div className="d-flex gap-14 mt-3.5 row">
                    <div className="col-3">
                        <input type="radio" id="internal" name="internal" value="false"
                               checked={!external}
                               onChange={() => setExternal(!external)}/>
                        <label htmlFor="internal" className="ml-2">Internal</label>
                    </div>
                    <div className="col-3">
                        <input type="radio" id="external" name="external" value="true"
                               checked={external}
                               onChange={() => setExternal(!external)}/>
                        <label htmlFor="external" className="ml-2">External</label>
                    </div>
                </div>
            )}


            <div className="grid grid-cols-12 mt-4 gap-5">


                <TextAreaField
                    label="Comment"
                    required
                    name={"noteBody"}
                    value={noteBody || ""}
                    onChange={(e) => {
                        e.preventDefault();
                        setNoteBody(e.target.value)
                    }}
                    className="w-full bg-text-0 rounded-md text-surface-0  border border-surface-5 p-2"
                    placeholder="Enter Note Body...."
                />

                {isFulfillmentNotes &&
                    <SelectField
                        placeholder='Select Account No..'
                        value={accountNumber || null}
                        options={createOptionListForSelectTag(parentAccountData, "accountNumber", "accountNumber")}
                        onChange={(selectedOption) => {
                            setAccountNumber(selectedOption)
                        }}
                        label={"Account No"}
                        isDisabled={!parentAccountData}
                    />
                }

                {isCertificateNote && setTargetCert && (
                    <SelectField
                        placeholder='Select Target Cert...'
                        value={targetCert || null}
                        options={createOptionListForSelectTag(enums?.["TargetCert"], "value", "constant")}
                        onChange={(selectedOption) => {
                            setTargetCert(selectedOption)
                        }}
                        label={"Target Cert"}
                    />
                )}

                {sort !== null && setSort !== null &&
                    <InputField
                        label={"Sort"}
                        type={"number"}
                        name={"saveAsCanned"}
                        value={sort}
                        onChange={(e: any) => setSort(Number(e.target.value))}
                    />
                }

                {hasPermission(["CANNOTE-C"]) && (

                    <InputField
                        label={"Saved As Canned"}
                        type={"checkbox"}
                        checked={saveAsCanned}
                        name={"saveAsCanned"}
                        onClick={() => setSaveAsCanned(!saveAsCanned)}
                    />
                )}

                {(isCertificateNote || saveAsCanned) && (
                    <>

                        <InputField
                            label={"Bold"}
                            type={"checkbox"}
                            checked={bold}
                            name={"bold"}
                            onClick={() => setBold(!bold)}
                        />
                        <InputField
                            label={"Red Color"}
                            type={"checkbox"}
                            checked={redColor}
                            name={"redColor"}
                            onClick={() => setRedColor(!redColor)}
                        />
                        <InputField
                            label={"Yellow Highlight"}
                            type={"checkbox"}
                            checked={yellowHighlight}
                            name={"yellowHighlight"}
                            onClick={() => setYellowHighlight(!yellowHighlight)}
                        />


                    </>

                )}
            </div>
        </>
    );
};

export default CustomNoteSection;